import {ChangeDetectionStrategy, Component, computed, DestroyRef, inject, input, OnInit, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AngularSvgIconModule} from 'angular-svg-icon';

import {SidebarComponent} from '../sidebar/sidebar.component';
import {NotificationsService} from '@shared/services/notifications.service';
import {DropdownComponent} from '../../components/ui/dropdown/dropdown.component';
import {DropdownTriggerForDirective} from '../../components/ui/dropdown/directives/dropdown-trigger-for.directive';
import {NotificationMenuComponent} from '../../components/views/notification-menu/notification-menu.component';
import {AccountMenuComponent} from '../../components/views/account-menu/account-menu.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AngularSvgIconModule, DropdownComponent, DropdownTriggerForDirective, NotificationMenuComponent, AccountMenuComponent]
})
export class HeaderComponent implements OnInit {

    readonly sidebar = input<SidebarComponent>();

    readonly notificationCount = signal(0);
    readonly hasNotifications = computed(() => this.notificationCount() > 0);
    readonly notificationsAriaLabel = computed(() => {
        switch (this.notificationCount()) {
            case 0:
                return 'Notifications Dropdown - no notifications listed';
            case 1:
                return 'Notifications Dropdown - 1 unread notification listed';
            default:
                return `Notifications Dropdown - ${this.notificationCount()} unread notifications listed`;
        }
    });

    private readonly _notificationsService = inject(NotificationsService);
    private readonly _destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        this._notificationsService.notifications.pipe(
            takeUntilDestroyed(this._destroyRef)
        ).subscribe(notifications => {
            this.notificationCount.set(notifications.length);
        });
    }
}
